import { render, staticRenderFns } from "./layActive.vue?vue&type=template&id=65f5d7e5&scoped=true"
import script from "./layActive.vue?vue&type=script&lang=js"
export * from "./layActive.vue?vue&type=script&lang=js"
import style0 from "./layActive.vue?vue&type=style&index=0&id=65f5d7e5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f5d7e5",
  null
  
)

export default component.exports